import React from 'react';

const CardForm = ({
  state,
  getValue,
  handleExpiryChange,
  handleExpiryFocus,
  getCcv,
  getName,
  handleSubmit,
  setState,
  theme,
}) => (
  <form className="card-form" onSubmit={handleSubmit} noValidate aria-label="Payment form">
    <label htmlFor="name">Nom</label>
    <input
      id="name"
      onChange={getName}
      type="text"
      placeholder="Nom du titulaire"
      value={state.name}
      required
      autoComplete="cc-name"
      aria-invalid={state.errormsg.includes('fill all required fields') && !state.name}
    />
    <label htmlFor="pan">Numéro de carte</label>
    <input
      id="pan"
      maxLength="19"
      onChange={(e) => getValue(e.target.value)}
      placeholder="XXXX XXXX XXXX XXXX"
      value={state.input}
      required
      autoComplete="cc-number"
      aria-invalid={state.errormsg.includes('Invalid card number')}
      aria-describedby="card-error"
    />
    <div className="row" id="expcvc">
      <label id="explabel" htmlFor="ExpiryDate">Valable jusqu'au</label>
      <input
        id="ExpiryDate"
        onChange={(e) => handleExpiryChange(e.target.value, e.target.selectionStart, e.target)}
        onFocus={handleExpiryFocus}
        placeholder="MM/YY"
        value={state.expiry}
        required
        aria-invalid={state.errormsg.includes('expiration')}
        aria-describedby="expiry-error"
      />
      <label id="cvclabel" htmlFor="cvv">CVV</label>
      <input
        id="cvv"
        onChange={(e) => getCcv(e.target.value)}
        placeholder="CVV"
        value={state.ccv}
        required
        aria-invalid={state.errormsg.includes('fill all required fields') && !state.ccv}
      />
    </div>
    <label 
      htmlFor="saveCard"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: typeof window !== 'undefined' && window.innerWidth <= 768 ? '10px' : '12px',
        marginTop: '18px',
        marginBottom: '18px',
        padding: typeof window !== 'undefined' && window.innerWidth <= 768 ? '12px 14px' : '14px 16px',
        background: state.saveCard 
          ? 'linear-gradient(135deg, rgba(180, 36, 58, 0.08) 0%, rgba(180, 36, 58, 0.04) 100%)'
          : 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
        border: state.saveCard 
          ? '2px solid rgba(180, 36, 58, 0.3)' 
          : '2px solid #e5e7eb',
        borderRadius: '12px',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        userSelect: 'none',
        boxShadow: state.saveCard 
          ? '0 4px 12px rgba(180, 36, 58, 0.15)' 
          : '0 2px 6px rgba(0, 0, 0, 0.05)',
      }}
      onMouseEnter={(e) => {
        if (!state.saveCard) {
          e.currentTarget.style.borderColor = '#b4243a';
          e.currentTarget.style.background = 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)';
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(180, 36, 58, 0.12)';
        }
      }}
      onMouseLeave={(e) => {
        if (!state.saveCard) {
          e.currentTarget.style.borderColor = '#e5e7eb';
          e.currentTarget.style.background = 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)';
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.05)';
        }
      }}
    >
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <input
          type="checkbox"
          id="saveCard"
          checked={state.saveCard || false}
          onChange={(e) => setState(prev => ({ ...prev, saveCard: e.target.checked }))}
          style={{
            position: 'absolute',
            opacity: 0,
            cursor: 'pointer',
          }}
          aria-label="Enregistrer la carte bancaire"
        />
        <div style={{
          width: typeof window !== 'undefined' && window.innerWidth <= 768 ? '22px' : '24px',
          height: typeof window !== 'undefined' && window.innerWidth <= 768 ? '22px' : '24px',
          borderRadius: '6px',
          border: state.saveCard ? '2px solid #b4243a' : '2px solid #d1d5db',
          background: state.saveCard 
            ? 'linear-gradient(135deg, #b4243a 0%, #8b0000 100%)' 
            : '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease',
          boxShadow: state.saveCard ? '0 2px 8px rgba(180, 36, 58, 0.3)' : 'none',
        }}>
          {state.saveCard && (
            <svg 
              width={typeof window !== 'undefined' && window.innerWidth <= 768 ? '12' : '14'} 
              height={typeof window !== 'undefined' && window.innerWidth <= 768 ? '12' : '14'} 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="white" 
              strokeWidth="3"
            >
              <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )}
        </div>
      </div>
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: typeof window !== 'undefined' && window.innerWidth <= 768 ? '8px' : '10px',
      }}>
        <div style={{
          width: typeof window !== 'undefined' && window.innerWidth <= 768 ? '32px' : '36px',
          height: typeof window !== 'undefined' && window.innerWidth <= 768 ? '32px' : '36px',
          borderRadius: '10px',
          background: state.saveCard 
            ? 'linear-gradient(135deg, rgba(180, 36, 58, 0.15) 0%, rgba(180, 36, 58, 0.08) 100%)'
            : 'linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease',
        }}>
          <svg 
            width={typeof window !== 'undefined' && window.innerWidth <= 768 ? '16' : '18'} 
            height={typeof window !== 'undefined' && window.innerWidth <= 768 ? '16' : '18'} 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={state.saveCard ? '#b4243a' : '#6b7280'} 
            strokeWidth="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: typeof window !== 'undefined' && window.innerWidth <= 768 ? '0.85rem' : '0.95rem',
            fontWeight: '600',
            color: state.saveCard ? '#b4243a' : '#1f2937',
            marginBottom: '2px',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            transition: 'color 0.3s ease',
          }}>
            Enregistrer la carte bancaire
          </div>
          <div style={{
            fontSize: typeof window !== 'undefined' && window.innerWidth <= 768 ? '0.7rem' : '0.75rem',
            color: '#6b7280',
            fontWeight: '400',
            lineHeight: '1.3',
          }}>
            Paiements plus rapides la prochaine fois
          </div>
        </div>
      </div>
    </label>
    <button
      type="submit"
      disabled={state.loading}
      className="modern-pay-button"
      style={{
        background: state.loading 
          ? 'linear-gradient(135deg, #9ca3af 0%, #6b7280 100%)'
          : 'linear-gradient(135deg, #b4243a 0%, #8b0000 100%)',
        color: 'white',
        padding: '16px',
        border: 'none',
        borderRadius: '14px',
        cursor: state.loading ? 'not-allowed' : 'pointer',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '56px',
        width: '100%',
        fontSize: '1.1rem',
        fontWeight: '700',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        boxShadow: state.loading 
          ? '0 4px 12px rgba(107, 114, 128, 0.3)'
          : '0 6px 20px rgba(180, 36, 58, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        letterSpacing: '0.02em',
        overflow: 'hidden',
      }}
      onMouseEnter={(e) => {
        if (!state.loading) {
          e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
          e.currentTarget.style.boxShadow = '0 10px 30px rgba(180, 36, 58, 0.5), 0 4px 12px rgba(0, 0, 0, 0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (!state.loading) {
          e.currentTarget.style.transform = 'translateY(0) scale(1)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(180, 36, 58, 0.4), 0 2px 8px rgba(0, 0, 0, 0.1)';
        }
      }}
      onMouseDown={(e) => {
        if (!state.loading) {
          e.currentTarget.style.transform = 'translateY(-1px) scale(0.98)';
        }
      }}
      onMouseUp={(e) => {
        if (!state.loading) {
          e.currentTarget.style.transform = 'translateY(-3px) scale(1.02)';
        }
      }}
      aria-busy={state.loading}
    >
      <span style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        gap: '10px',
        position: 'relative',
        zIndex: 1,
      }}>
        {!state.loading && (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M9 11l3 3L22 4"></path>
            <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>
          </svg>
        )}
        <span>Payer</span>
        <span style={{ 
          color: '#fcd34d', 
          fontWeight: '800', 
          fontSize: '1.15rem',
          textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          letterSpacing: '0.03em'
        }}>
          {parseFloat(state.amount).toFixed(2)} MAD
        </span>
        {state.loading && (
          <span
            className="spinner"
            style={{
              width: '20px',
              height: '20px',
              borderWidth: '3px',
              borderLeftColor: '#fff',
              borderTopColor: '#fff',
              borderBottomColor: 'rgba(255,255,255,0.3)',
              borderRightColor: 'rgba(255,255,255,0.3)',
            }}
            aria-label="Loading"
          />
        )}
      </span>
    </button>
  </form>
);

export default CardForm;